import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=b7157c0c&scoped=true&"
import script from "./NotificationModal.vue?vue&type=script&lang=js&"
export * from "./NotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=b7157c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7157c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7157c0c')) {
      api.createRecord('b7157c0c', component.options)
    } else {
      api.reload('b7157c0c', component.options)
    }
    module.hot.accept("./NotificationModal.vue?vue&type=template&id=b7157c0c&scoped=true&", function () {
      api.rerender('b7157c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/NotificationModal.vue"
export default component.exports